<!--
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：ヘッダーメニュー
 *
 * 作成者：2021/11/22 ノア）虞
 * 最終修正者：2022/02/8 ノア）黄
 *
 -->
<template>
  <header>
    <div class="nav">
      <div class="nav-content">
        <div class="dis-flex">
          <!-- メニューボタン -->
          <div class="nav-bar" @click="onCheckSilderBarStatus">
            <el-button>
              <tti-svg-icon icon-name="he_001"></tti-svg-icon>
            </el-button>
          </div>
          <!-- ロゴ -->
          <div class="logo">
            <img src="../assets/images/header.png" alt />
          </div>
          <!-- ダイナミックメニュー -->
          <div class="top-menu">
            <el-button
              class="menu-btn"
              v-for="menuId in favoriteMenuList.slice(0, 3)"
              :key="menuId"
              @click="onMenuClick(menuId)"
              v-tooltip="{
                content: `${getDefinitionName(menuMaster, menuId, { code: 'code', value: 'tip' })}`,
                placement: 'bottom-start',
                delay: { show: 1000, hide: 0 }
              }"
              >{{ getDefinitionName(menuMaster, menuId) }}</el-button
            >
            <el-popover
              v-if="favoriteMenuList.length > 3"
              :close-delay="0"
              trigger="hover"
              :visible-arrow="false"
              popper-class="menu-popper"
            >
              <template>
                <div
                  class="menu-items-child"
                  v-for="subMenuId in favoriteMenuList.slice(3)"
                  :key="subMenuId"
                  @click="onMenuClick(subMenuId)"
                  v-tooltip="{
                    content: `${getDefinitionName(menuMaster, subMenuId, { code: 'code', value: 'tip' })}`,
                    placement: 'bottom-start',
                    delay: { show: 1000, hide: 0 }
                  }"
                >
                  {{ getDefinitionName(menuMaster, subMenuId) }}
                </div>
              </template>
              <el-button slot="reference"><tti-svg-icon icon-name="he_002"></tti-svg-icon></el-button>
            </el-popover>
          </div>
        </div>
        <div class="dis-flex">
          <!-- アイコンメニュー -->
          <div class="icon-menu">
            <el-button
              @click="onFavClick"
              v-tooltip="{
                content: `${$t('headerMenu.favTip')}`,
                placement: 'bottom-start',
                delay: { show: 1000, hide: 0 }
              }"
            >
              <tti-svg-icon icon-name="he_003"></tti-svg-icon>
            </el-button>
            <el-button
              @click="onHomeClick"
              v-tooltip="{
                content: `${$t('headerMenu.homeTip')}`,
                placement: 'bottom-start',
                delay: { show: 1000, hide: 0 }
              }"
              ><tti-svg-icon icon-name="he_004"></tti-svg-icon
            ></el-button>
            <el-badge :value="messageCount" class="message-badge" v-if="messageCount">
              <el-button
                class="message-btn"
                @click="onNotificationsBtnClick"
                v-tooltip="{
                  content: `${$t('headerMenu.messageTip')}`,
                  placement: 'bottom-start',
                  delay: { show: 1000, hide: 0 }
                }"
                ><tti-svg-icon icon-name="he_005"></tti-svg-icon>
              </el-button>
            </el-badge>
            <el-button
              v-if="!messageCount"
              @click="onNotificationsBtnClick"
              v-tooltip="{
                content: `${$t('headerMenu.messageTip')}`,
                placement: 'bottom-start',
                delay: { show: 1000, hide: 0 }
              }"
              ><tti-svg-icon icon-name="he_005"></tti-svg-icon>
            </el-button>
            <el-button
              @click="onPhoneBtnClick"
              v-tooltip="{
                content: `${$t('headerMenu.callerTip')}`,
                placement: 'bottom-start',
                delay: { show: 1000, hide: 0 }
              }"
              ><tti-svg-icon icon-name="he_006"></tti-svg-icon
            ></el-button>
            <el-button
              @click="onHelpBtnClick"
              v-tooltip="{
                content: `${$t('headerMenu.helperTip')}`,
                placement: 'bottom-start',
                delay: { show: 1000, hide: 0 }
              }"
              ><tti-svg-icon icon-name="he_007"></tti-svg-icon
            ></el-button>
            <el-button
              @click="onPrintClick"
              v-tooltip="{
                content: `${$t('headerMenu.printTip')}`,
                placement: 'bottom-start',
                delay: { show: 1000, hide: 0 }
              }"
              ><tti-svg-icon icon-name="he_008"></tti-svg-icon
            ></el-button>
            <el-button
              @click="onSystemInfoBtnClick"
              v-tooltip="{
                content: `${$t('headerMenu.systemInfoTip')}`,
                placement: 'bottom-start',
                delay: { show: 1000, hide: 0 }
              }"
              ><tti-svg-icon icon-name="he_009"></tti-svg-icon
            ></el-button>
          </div>
          <div class="tti-select-office">
            <el-popover
              popper-class="selectOfficeHeight"
              ref="businessOfficeSelector"
              v-show="showBusinessOfficeSelector"
              placement="bottom"
              width="400"
              trigger="manual"
              v-model="isBusinessOfficeSelectorVisible"
              @hide="onBussinessOfficeSelected"
              v-tooltip="{
                content: `${$t('headerMenu.selectOfficeTip')}`,
                placement: 'bottom-start',
                delay: { show: 1000, hide: 0 }
              }"
            >
              <el-button slot="reference" @click="onBussinessOfficeSelecterClick">{{
                $t('headerMenu.selectOffice')
              }}</el-button>
              <el-input v-model.trim="businessOfficeFilterText">
                <tti-svg-icon class="input__icon" slot="suffix" icon-name="su_016"></tti-svg-icon>
              </el-input>
              <el-tree
                :data="officeOptions"
                show-checkbox
                node-key="id"
                default-expand-all
                :check-on-click-node="true"
                :check-strictly="true"
                :expand-on-click-node="false"
                :filter-node-method="filteBusinessOfficerNode"
                @check="onSelectedOfficeChange"
                ref="businessOfficeTree"
              >
              </el-tree>
            </el-popover>
          </div>
          <!-- ユーザー情報 -->
          <div class="tti-user">
            <el-popover :close-delay="0" trigger="hover" :visible-arrow="false" popper-class="menu-popper">
              <div
                class="menu-items-child"
                @click="onUpdatePassword"
                v-tooltip="{
                  content: `${$t('headerMenu.updatepasswordTip')}`,
                  placement: 'bottom-start',
                  delay: { show: 1000, hide: 0 }
                }"
              >
                <tti-svg-icon icon-name="wo_009"></tti-svg-icon>
                <span class="tti-user-text">{{ $t('headerMenu.updatePassword') }}</span>
              </div>
              <div
                class="menu-items-child"
                @click="onMFASwitch"
                v-tooltip="{
                  content: `${$t('headerMenu.mfaSwitchTip')}`,
                  placement: 'bottom-start',
                  delay: { show: 1000, hide: 0 }
                }"
              >
                <tti-svg-icon icon-name="wo_009"></tti-svg-icon>
                <span class="tti-user-text">{{ $t('headerMenu.mfaSwitch') }}</span>
              </div>
              <div
                class="menu-items-child"
                @click="onLogout"
                v-tooltip="{
                  content: `${$t('headerMenu.loginoutTip')}`,
                  placement: 'bottom-start',
                  delay: { show: 1000, hide: 0 }
                }"
              >
                <tti-svg-icon icon-name="su_001"></tti-svg-icon>
                <span class="tti-user-text">{{ $t('headerMenu.loginout') }}</span>
              </div>
              <el-avatar size="medium" class="cursor-pointer" icon="el-icon-user-solid" slot="reference"></el-avatar>
            </el-popover>
            <div class="user-info">
              <div>{{ userName }}</div>
              <div>{{ companyInfo }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Tree, Popover } from 'element-ui'
import { cloneDeep, indexOf } from 'lodash'
import { AxiosResponse } from 'axios'

import { dialog, common } from '@/store/modules'
import config from '@/config/config'
import masterConfig from '@/config/masterConfig'
import { getMenuMasterConfig } from '@/config'
import manualConfig from '@/config/manualConfig'
import localStorageConfig from '@/config/localStorageConfig'
import { setLocalStorage } from '@/utils/localStorageUtils'
import { TreeData, AllocationOfficeItem, ResponseData } from '@/models'
import { getCorporateMasterData, getSalesOfficeAllocationData, postLogout } from '@/store/apis'
import { clearLocal, clearSession } from '@/commons/services/localService'
import HelperService from '@/service/helperService'
import { msgBoxService } from '@/commons/services/msgBoxService'
import { BookmarksTargetType, ScreenListMenuId, UserRole } from '@/commons/constants'
import { i18n } from '@/locales'
import { BookmarksParam } from '@/models/home'
import { getBookmarks, updateBookmarks } from '@/store/apis'
import { localService } from '@/commons/services/localService'
import { moveService } from '@/commons/services/moveService'
import { globalOfficeService } from '@/commons/services/globalOfficeService'
import packageConfig from '../../package.json'
import { clearWindowCookie } from '@/service/refreshAndCloseWindowService'

@Component({
  name: 'TtiHeader'
})
export default class TtiHeader extends Vue {
  /**
   * 所属営業所ID
   *
   * @returns {string} 所属営業所ID
   */
  get mainOfficeId(): string {
    return localService.userInfo?.businessOfficeId || ''
  }

  /**
   * 営業所関係エラー状態を取得する。
   *
   * @returns {boolean} 営業所関係エラー状態
   */
  get isBussinessOfficeStatusError(): boolean {
    return common.isBussinessOfficeStatusError
  }

  /**
   * ユーザー名
   *
   * @returns {string} ユーザー名
   */
  get userName(): string {
    if (!localService.userInfo?.companyPrefix && !packageConfig.version) {
      return `${localService.userInfo?.userName || ''}`
    }

    if (localService.userInfo?.companyPrefix && packageConfig.version) {
      return `${localService.userInfo?.userName || ''}(V${packageConfig.version}-${
        localService.userInfo?.companyPrefix
      })`
    }

    return `${localService.userInfo?.userName || ''}(${localService.userInfo?.companyPrefix || ''}${
      packageConfig.version || ''
    })`
  }

  /**
   * 企業情報
   *
   * @returns {string} 企業情報
   */
  get companyInfo(): string {
    if (!localService.userInfo?.companyCode) {
      return `${localService.userInfo?.companyName || ''}`
    }

    if (localService.userInfo?.companyCode) {
      return `${localService.userInfo?.companyName || ''}(${localService.userInfo?.companyCode})`
    }

    return `${localService.userInfo?.companyName || ''}(${localService.userInfo?.companyCode || ''})`
  }

  /**
   * 気に入りメニュー
   */
  favoriteMenuList: string[] = []

  /**
   * 気に入り営業所リスト
   */
  favoriteOfficeIdList: string[] = []

  /**
   * 気に入り営業所リスト
   */
  favoriteOfficeIdListCache: string[] = []

  /**
   * 機能一覧汎用定義
   */
  menuMaster = getMenuMasterConfig().menuMaster

  /**
   * 気に入りメニュー
   *
   * @returns {string[]} 気に入りメニュー
   */
  get watchedFavMenuList(): string[] {
    return common.favMenuList
  }

  /**
   * 未読合計
   *
   * @returns {number} 未読合計
   */
  get messageCount(): number {
    return common.unreadTotalCount
  }

  /**
   * 営業所選択変更（WATCH用）
   *
   * @returns {number} 営業所選択変更（WATCH用）
   */
  get businessOfficeChange(): number {
    return common.businessOfficeChange
  }

  /**
   * ダイアログボックスを表示するかどうかを取得する（画面用）
   *
   * @returns {boolean} ダイアログボックスを表示するかどうか（画面用）
   */
  get isShow(): boolean | undefined {
    this.initMenuList()
    return dialog.silderBarIsShow
  }

  /**
   * 営業所フィルター
   */
  theBusinessOfficeFilterText = ''

  /**
   * 営業所フィルター
   *
   * @returns {void}
   */
  set businessOfficeFilterText(value: string) {
    this.theBusinessOfficeFilterText = value
    ;(this.$refs.businessOfficeTree as Tree).filter(value)
  }

  /**
   * 営業所フィルター
   *
   * @returns {string} 営業所フィルター
   */
  get businessOfficeFilterText(): string {
    return this.theBusinessOfficeFilterText
  }

  notShowBusinessOfficeSelectorUrlList = masterConfig.notShowBusinessOfficeSelectorUrlList

  get showBusinessOfficeSelector(): boolean {
    const path = this.$route.path
    return indexOf(this.notShowBusinessOfficeSelectorUrlList, path) === -1
  }

  /**
   * 営業所情報
   */
  officeOptions: TreeData[] = []

  getDefinitionName = HelperService.getDefinitionName

  /**
   * 気に入りメニュー変更した時の処理
   *
   * @param {string[]} value  気に入りメニュー
   * @returns {void}
   */
  @Watch('watchedFavMenuList', { immediate: true, deep: true })
  onDataChange(value: string[]): void {
    this.favoriteMenuList = cloneDeep(value)
  }

  /**
   * 営業所関係エラー状態を変更した時の処理
   *
   * @returns {void}
   */
  @Watch('isBussinessOfficeStatusError')
  selectBusinessOffice(): void {
    if (!this.isBussinessOfficeStatusError) {
      return
    }

    this.fetchSalesOfficeAllocationMaster()
    common.setBussinessOfficeStatus(false)
  }

  /**
   * インスタンスがマウントされたちょうど後にフック処理
   *
   * @returns {void}
   */
  async mounted(): Promise<void> {
    this.$log.debug('TtiHeader > mounted')
    this.fetchSalesOfficeAllocationMaster()
    this.initPopoverLisener()
    if (localService.userInfo.role === UserRole.SYSTEM) {
      await this.connectCompany()
    }
    this.judgeMenuShow()
  }

  /**
   * メニュー情報初期化
   */
  initMenuList(): void {
    this.menuMaster = getMenuMasterConfig().menuMaster
  }

  /**
   * 機能一覧サブ画面の表示フラグを設定する
   *
   */
  judgeMenuShow(): void {
    if (localService.itpConnectValidFlag === '1') {
      this.menuMaster.push({
        code: 'connectCompanyMaster',
        value: i18n.t('menu.connectCompanyMaster').toString(),
        tip: i18n.t('menu.connectCompanyMasterTip').toString()
      })
    }
  }

  /**
   * ITP連携有効フラグ.
   */
  async connectCompany(): Promise<void> {
    const corporateMasterData = await getCorporateMasterData()
    localService.itpConnectValidFlag = corporateMasterData.itpConnectValidFlag
  }

  /**
   * 営業所割当マスタを取得する
   *
   * @returns {void}
   */
  @Watch('businessOfficeChange')
  async fetchSalesOfficeAllocationMaster(): Promise<void> {
    try {
      const masters = await getSalesOfficeAllocationData()
      const officeMasterData = (masters.businessOfficeList as AllocationOfficeItem[]) || []
      this.officeOptions = HelperService.formatofficeData(officeMasterData)

      this.fetchBookmarksData(officeMasterData)
    } catch (e) {
      this.$log.debug('TtiHeader > fetchSalesOfficeAllocationMaster: e=', e)
      throw e
    }
  }

  /**
   * お気に入り営業所を取得する。
   *
   * @param {AllocationOfficeItem[]} officeMasterData 営業所割当
   * @returns {void}
   */
  async fetchBookmarksData(officeMasterData: AllocationOfficeItem[]): Promise<void> {
    try {
      const bookmarks = await getBookmarks()

      this.favoriteOfficeIdList = bookmarks.businessOfficeIdList ? bookmarks.businessOfficeIdList : []
      this.favoriteMenuList = bookmarks.functionIdList ? bookmarks.functionIdList : []

      this.favoriteOfficeIdList = this.favoriteOfficeIdList.filter(item => {
        let isExist = false
        for (const office of officeMasterData) {
          if (office.businessOfficeId === item) {
            isExist = true
            break
          }
        }
        if (isExist) {
          return true
        } else {
          return false
        }
      })

      this.setCheckedOffice()
      this.favoriteOfficeIdListCache = cloneDeep(this.favoriteOfficeIdList)
      common.setFavMenuList(this.favoriteMenuList)
      common.setFavOfficeList(this.favoriteOfficeIdList)
    } catch (e) {
      this.$log.debug('HOME_FAV > fetchBookmarksData: e=', e)
      throw e
    }
  }

  /**
   * 営業所フィルターの値によって、ツリーのノードをフィルターする
   *
   * @param {string} value フィルターする値
   * @param {TreeData} data フィルター対象のノード
   * @returns {boolean} フィルター結果
   */
  filteBusinessOfficerNode(value: string, data: TreeData): boolean {
    if (!value) return true
    return data.label.indexOf(value) !== -1
  }

  /**
   * 「営業所選択」を閉じた時の処理
   *
   * @returns {void}
   */
  onBussinessOfficeSelected(): void {
    this.favoriteOfficeIdList = (this.$refs.businessOfficeTree as Tree).getCheckedKeys()
    this.$log.debug('TtiHeader', 'onBussinessOfficeSelected > checkedKeys=', this.favoriteOfficeIdList)

    if (this.favoriteOfficeIdList.length === 0) {
      msgBoxService.error(i18n.t('headerMenu.officeNumber').toString(), () => {
        this.favoriteOfficeIdList = [this.mainOfficeId]
        this.setCheckedOffice()
        this.saveBookmarksData()
      })
      return
    }

    this.saveBookmarksData()
  }

  /**
   * 営業所選択値を設定する
   *
   * @returns {void}
   */
  setCheckedOffice(): void {
    ;(this.$refs.businessOfficeTree as Tree).setCheckedKeys(this.favoriteOfficeIdList)
  }

  /**
   * お気に入りを更新する。
   *
   * @returns {void}
   */
  async updateBookmarksData(): Promise<void> {
    try {
      const updateBookmarksParam: BookmarksParam = {
        target: BookmarksTargetType.SALES_OFC,
        businessOfficeIdList: this.favoriteOfficeIdList
      }

      await updateBookmarks(updateBookmarksParam)

      common.makeBusinessOfficeChange()
      this.favoriteOfficeIdListCache = cloneDeep(this.favoriteOfficeIdList)
    } catch (e) {
      this.$log.debug('TtiHeader > updateBookmarksData: e=', e)
      const err = e as AxiosResponse<ResponseData>
      // エラーメッセージコードが「E00090」の場合、「営業所割当」を再取得する
      if (err.data.common.code === 'E00090') {
        this.fetchSalesOfficeAllocationMaster()
      }
      throw e
    }
  }

  /**
   * 営業所選択時に、営業所情報を保存する
   *
   * @returns {void}
   */
  saveBookmarksData(): void {
    if (!this.checkDataChanged()) {
      return
    }
    common.setFavOfficeList(this.favoriteOfficeIdList)
    this.updateBookmarksData()
  }

  /**
   * リストが変更されましたかをチェックする。
   *
   * @returns {boolean} isChanged
   */
  checkDataChanged(): boolean {
    return HelperService.isTableDataChanged(this.favoriteOfficeIdListCache, this.favoriteOfficeIdList)
  }

  /**
   * サイドバーの表示状態を切り替
   *
   * @returns {void}
   */
  onCheckSilderBarStatus(): void {
    dialog.setSilderBarIsShow()
  }

  /**
   * パスワード変更の表示状態を切り替
   *
   * @returns {void}
   */
  onUpdatePassword(): void {
    dialog.setUpdatePsIsShow()
  }

  /**
   * MFA認定スイッチ変更の表示状態を切り替
   */
  onMFASwitch(): void {
    dialog.setMFASwitchIsShow()
  }

  /**
   * ログアウト
   *
   * @returns {void}
   */
  onLogout(): void {
    const confirmCallback = async () => {
      await moveService.beforeLogout()
      this.doLogout()
    }

    msgBoxService.confirm(i18n.t('messages.logoutConfirm').toString(), confirmCallback)
  }

  /**
   * ログアウトを実行する。
   *
   * @returns {void}
   */
  async doLogout(): Promise<void> {
    try {
      await postLogout()
      clearLocal()
      clearSession()
      HelperService.removeAccessToken()
      clearWindowCookie()
      Vue.nextTick(() => {
        this.$router.push(config.menu.login)
      })
    } catch (e) {
      Vue.$log.debug('Login > onLogout: e=', e)
      throw e
    }
  }

  onManagementListClick(): void {
    dialog.setScreenDialogShow(true)
  }

  /**
   * 「通知」ボタンをクリックした時の処理
   *
   * @returns {void}
   */
  onNotificationsBtnClick(): void {
    this.$log.debug('TtiHeader', 'onNotificationsBtnClick')
    dialog.setNotificationsDialogShow()
  }

  /**
   * 「電話」ボタンをクリックした時の処理
   *
   * @returns {void}
   */
  onPhoneBtnClick(): void {
    this.$log.debug('TtiHeader', 'onPhoneBtnClick')
    dialog.setPhoneCCDialogShow(true)
  }

  /**
   * 「マニュアル」ボタンをクリックした時の処理
   *
   * @returns {void}
   */
  onHelpBtnClick(): void {
    this.$log.debug('TtiHeader', 'onSystemIonHelpBtnClickfoBtnClick')
    setLocalStorage(localStorageConfig.baseKey, {
      [localStorageConfig.helpFileName]: ''
    })
    window.open(manualConfig.route.help, '_blank')
  }

  /**
   * 「このシステムについて」ボタンをクリックした時の処理
   *
   * @returns {void}
   */
  onSystemInfoBtnClick(): void {
    this.$log.debug('TtiHeader', 'onSystemInfoBtnClick')
    window.open(manualConfig.route.aboutMe, '_blank')
  }

  /**
   * 「お気に入り」ボタンをクリックした時の処理
   *
   * @returns {void}
   */
  onFavClick(): void {
    dialog.setFavoriteDialogShow(true)
  }

  /**
   * 「ホーム」ボタンをクリックした時の処理
   *
   * @returns {void}
   */
  onHomeClick(): void {
    this.$log.debug('TtiHeader', 'onHomeClick')
    this.$router.push(config.menu.home)
  }

  /**
   * 「印刷」ボタンをクリックした時の処理
   *
   * @returns {void}
   */
  onPrintClick(): void {
    this.$log.debug('TtiHeader', 'onPrintClick')
    window.print()
  }

  /**
   * メニューをクリックした時の処理
   *
   * @param {string} menuId メニューID
   * @returns {void}
   */
  onMenuClick(menuId: string): void {
    if (menuId === ScreenListMenuId) {
      this.onManagementListClick()
    } else {
      this.$router.push(config.menu[menuId])
    }
  }

  /**
   * インスタンスが破棄された後にフック処理(VUEからextends)
   *
   * @returns {void}
   */
  destroyed(): void {
    this.removePopoverLisener()
  }

  /**
   * 「営業所選択」ポップアップがひょうじするかどうかのフラグ
   */
  isBusinessOfficeSelectorVisible = false

  /**
   * 「営業所選択」をクリックじた時の処理
   *
   * @returns {void}
   */
  onBussinessOfficeSelecterClick(): void {
    if (!globalOfficeService.beforeGlobalOfficeChange) {
      this.isBusinessOfficeSelectorVisible = true
      return
    }

    globalOfficeService.beforeGlobalOfficeChange(
      // next
      (): void => {
        this.$log.debug('TtiHeader', 'onBussinessOfficeSelecterClick', 'next')
        this.isBusinessOfficeSelectorVisible = true
      }
    )
  }

  /**
   * 営業所ポップアップの設定を初期化する
   *
   * @returns {void}
   */
  initPopoverLisener(): void {
    const businessOfficeSelector = this.$refs.businessOfficeSelector as Popover
    ;(businessOfficeSelector.$refs.popper as Element).addEventListener(
      'mouseleave',
      this.handlerBusinessSelectorPopoverMouseLeave.bind(this)
    )
  }

  /**
   * 営業所ポップアップの設定を初期化する
   *
   * @returns {void}
   */
  removePopoverLisener(): void {
    const businessOfficeSelector = this.$refs.businessOfficeSelector as Popover
    if (!businessOfficeSelector || !businessOfficeSelector.$refs || !businessOfficeSelector.$refs.popper) {
      return
    }
    ;(businessOfficeSelector.$refs.popper as Element).removeEventListener(
      'mouseleave',
      this.handlerBusinessSelectorPopoverMouseLeave.bind(this)
    )
    ;(businessOfficeSelector.$refs.popper as Element).removeEventListener(
      'mouseleave',
      this.handlerBusinessSelectorPopoverMouseLeave.bind(this)
    )
  }

  /**
   * 営業所ポップアップの設定を初期化する
   *
   * @returns {void}
   */
  handlerBusinessSelectorPopoverMouseLeave(): void {
    this.isBusinessOfficeSelectorVisible = false
  }

  /**
   * 選択中の営業所情報を変更した時の処理
   *
   * @param {TreeData} data 選択したデータ
   * @param {any} node 選択されたノード
   * @returns {void}
   */
  // eslint-disable-next-line
  onSelectedOfficeChange(data: TreeData, node: any): void {
    this.favoriteOfficeIdList = (this.$refs.businessOfficeTree as Tree).getCheckedKeys()
    this.$log.debug('Header > onSelectedOfficeChange', this.favoriteOfficeIdList)
    if (!data.children?.length) {
      return
    }

    this.checkNode(data.children, node.checkedKeys)
  }

  /**
   * すべての下位層を選択
   *
   * @param {TreeData[]} arr 選択したサブノードデータ
   * @param {string[]} checkedKeys 選択のリストID
   * @returns {void}
   */
  checkNode(arr: TreeData[], checkedKeys: string[]): void {
    arr.forEach((item: TreeData) => {
      if (!item.parentId) {
        return
      }
      const isSelected = checkedKeys.includes(item.parentId)
      if (isSelected) {
        checkedKeys.push(item.id)
      } else {
        checkedKeys = checkedKeys.filter(it => item.id !== it)
      }
      ;(this.$refs.businessOfficeTree as Tree).setChecked(item, isSelected, false)
      if (item.children !== undefined) {
        this.checkNode(item.children, checkedKeys)
      }
    })
  }
}
</script>

<style scoped lang="scss">
.nav {
  height: 48px;
  overflow: hidden;
  box-sizing: border-box;
}

.nav-content {
  padding: 4px 12px;
  display: flex;
  justify-content: space-between;
}

.dis-flex {
  display: flex;
  align-items: center;
}

.nav-bar {
  display: inline-block;

  button {
    padding: 0;
    background: none;

    i {
      font-size: 30px;
    }
  }
}

.logo img {
  height: 40px;
}

.top-menu {
  padding: 0 12px 0 130px;

  button {
    padding: 6px 12px;
    background: none;
    border: none;
    outline: none;
    min-width: 50px;
    overflow: hidden;
    margin: 0;
  }
}

.icon-menu {
  button {
    padding: 0;
    background: none;
    margin: 0 12px 0 0;
  }
}

.message-badge {
  margin-right: 20px;

  ::v-deep .el-badge__content.is-fixed {
    top: 6px !important;
    font-weight: bold;
    border: none;
  }
}

.message-btn {
  margin: 0 !important;
}

.tti-select-office {
  margin-left: 20px;
  width: 176px;

  ::v-deep .el-button {
    padding: 8px 20px;
    border: 1px solid #d4d4d4 !important;
    width: 100%;
    color: $C07;

    &:hover,
    &:focus {
      @include bt_002_h;
    }

    &:active {
      @include bt_002_p;
    }
  }
}

.tti-user {
  margin-left: 32px;
  display: flex;
  align-items: center;

  .user-info {
    margin-left: 12px;
    font-size: $FS03;
  }

  .popover {
    padding: 0 !important;
  }
}

.popover-btn-first {
  cursor: pointer;

  span {
    padding-left: 10px;
  }
}

.popover-btn-first:hover {
  background: rgba(102, 128, 238, 0.15);
}

.popover-btn {
  cursor: pointer;

  span {
    padding-left: 10px;
  }
}

.popover-btn:hover {
  background: rgba(102, 128, 238, 0.15);
}

.menu-items-child {
  height: 40px;
  padding: 0 12px;
  display: flex;
  align-items: center;

  &:hover {
    cursor: pointer;
    color: #409eff;
    border-color: #c6e2ff;
    background-color: rgba(102, 128, 238, 0.15);
  }
}

.tti-user-text {
  padding-left: 6px;
}

.cursor-pointer {
  cursor: pointer;
}
</style>

<style lang="scss">
/* ポップオーバーはスタイルの変更 */
.menu-popper {
  padding: 0;
  margin-top: 6px !important;
}

.selectOfficeHeight {
  max-height: 500px;
  overflow: auto;
}
</style>
